<div class="card mb-2 rounded">
  <div class="card-body">
    <div class="card-title d-flex align-items-center justify-content-between w-100">
      <h3>
        {{item?.nome}}
      </h3>
      <span class="badge text-bg-primary ms-1" *ngIf="hasAutorization && (item.richieste && item.richieste.length > 0)">{{item?.richieste[0]?.stato}}</span>
      <span class="badge text-bg-primary ms-1" *ngIf="hasAutorization && (item.clienti_brand_retailer && item.clienti_brand_retailer.length > 0)">{{item?.clienti_brand_retailer[0]?.stato}}</span>
      <!-- <span class="badge text-bg-dark ms-1"
        [hidden]="!item.richieste[0] || hasAutorization">{{item.richieste[0]?.stato}}</span> -->
    </div>

    <div class="container-fluid mt-2">
      <div class="row">
        <div class="col-2 d-inline-flex align-items-center justify-content-center">
            <i class="bi bi-shop me-1 fs-1"></i>
          <!-- <img [src]="item.media_path" class="img-fluid ratio ratio-1x1 brand-img"> -->
        </div>

        <div class="col-10">
          <div class="list-group list-group-flush mb-2">
            <a [hidden]="!item.telefono" [href]="'tel:' + item.telefono" class="list-group-item list-group-item-action">
              <i class="bi bi-telephone"></i>
              {{item?.telefono}}
            </a>
            <a [href]="'mailto:' + item.email" class="list-group-item list-group-item-action">
              <i class="bi bi-envelope"></i>
              {{item?.email}}
            </a>
            <li class="list-group-item" [hidden]="!item.indirizzo">
              <i class="bi bi-geo-alt"></i>
              {{item?.indirizzo}};
              {{item?.cap}} {{item?.citta}} {{item?.nazione}}
            </li>
          </div>

          <div class="btn-group mb-2 mt-2" role="group" aria-label="Social Links">
            <a [hidden]="!item.sito_web" target="_blank" [href]="item.sito_web" class="btn btn-light">
              <i class="bi bi-globe"></i>
            </a>

            <a [hidden]="!item.facebook" target="_blank" [href]="item.facebook" class="btn btn-light">
              <i class="bi bi-facebook"></i>
            </a>

            <a [hidden]="!item.twitter" target="_blank" [href]="item.twitter" class="btn btn-light">
              <i class="bi bi-twitter"></i>
            </a>

            <a [hidden]="!item.instagram" target="_blank" [href]="item.instagram" class="btn btn-light">
              <i class="bi bi-instagram"></i>
            </a>

            <a [hidden]="!item.linkedin" target="_blank" [href]="item.linkedin" class="btn btn-light">
              <i class="bi bi-linkedin"></i>
            </a>

            <a [hidden]="!item.pinterest" target="_blank" [href]="item.pinterest" class="btn btn-light">
              <i class="bi bi-pinterest"></i>
            </a>
          </div>

          <div class="container-fluid mt-2"
            [hidden]="(!(item.richieste == null || item.richieste.length == 0 || (item.richieste[0].stato !== 'NON AUTORIZZATO' && item.richieste[0].stato !== 'AUTORIZZATO' && item.richieste[0].stato !== 'IN_ATTESA'))) ||
                      (!(item.clienti_brand_retailer == null || item.clienti_brand_retailer.length == 0 || (item.clienti_brand_retailer[0].stato !== 'NON AUTORIZZATO' && item.clienti_brand_retailer[0].stato !== 'AUTORIZZATO' && item.clienti_brand_retailer[0].stato !== 'IN_ATTESA')))">
            <button class="btn btn-primary" (click)="selectBrand(item)" data-bs-toggle="modal" data-bs-target="#requestBrendModal">
              COLLEGATI
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
